import { OnboardingDialog } from './onboarding-dialog';
import { useUserContext } from '../../../Contexts/User';
import { V2_ONBOARDING_CUTOFF_DATE } from '@/new/constants/onboarding';

interface MattersWelcomeOnboardingProps {
  onTakeTour?: () => void;
}

/**
 * Welcome to Wexler 2.0 onboarding dialog shown on the Matters list page.
 * Only shown to existing users (created before Nov 28, 2025) to explain the V2 changes.
 */
export function MattersWelcomeOnboarding({ onTakeTour }: MattersWelcomeOnboardingProps) {
  const { user } = useUserContext();

  // Only show V2 onboarding to existing users (created before cutoff date)
  const userCreatedAt = user?.createdAt ? new Date(user.createdAt) : null;
  const isExistingUser = userCreatedAt && userCreatedAt < V2_ONBOARDING_CUTOFF_DATE;

  if (!isExistingUser) {
    return null;
  }

  return (
    <OnboardingDialog dialogId="matters-welcome" icon="lucide--sparkles" title="Wexler 2.0" onTakeTour={onTakeTour}>
      <h3 className="text-lg font-medium">Welcome to Wexler 2.0!</h3>
      <p>We have upgraded our product to make it easier for you to work across all documents in a Matter.</p>
      <p>
        Instead of creating a Matter, then creating Cases and uploading to these, you now upload all your documents to
        the Matter.
      </p>
      <p>
        We've renamed <strong>Cases</strong> to <strong>Subsets</strong>. Subsets are collections of documents within
        your Matter through which you can view data from only those documents.
      </p>
    </OnboardingDialog>
  );
}
